import { render, staticRenderFns } from "./PreSchool.vue?vue&type=template&id=190b7250&scoped=true"
import script from "./PreSchool.vue?vue&type=script&lang=js"
export * from "./PreSchool.vue?vue&type=script&lang=js"
import style0 from "./PreSchool.vue?vue&type=style&index=0&id=190b7250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b7250",
  null
  
)

export default component.exports